import React, { useEffect, useState } from 'react';
import UModal from 'ubs-framework/v2/UModal/NewUModal';
import UButton from "ubs-framework/v2/UButton";
import UCheckBox from 'ubs-framework/v2/UCheckBox';
import UAlertMessage from 'ubs-framework/v2/UAlertMessage';
import { sendData } from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import useSocket from '../../common/useSocket';
import { copyLink, Decryption, showToastError, showToastSuccess } from 'ubs-framework/v2/common/function';
import OtpInput from 'react-otp-input';
import Layout from '../../../components/layout/Layout';
import { useHistory } from 'react-router-dom';
import AppHeader from '../../common/components/app-header';
import * as Icon from 'ubs-icons';
import { COLOR } from 'ubs-framework/v2/common/constant';
import { withRouter } from '../../../common/hocs/routing-hoc';
import { Encryption } from 'ubs-framework/v2/common/function';
import UPopup from "ubs-framework/v2/UPopup";
import LayoutV2 from '../../../components/layout-v2';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const SetUpMultiFactor = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const _LID = useSelector(e => e?.common?.logInDetails)
    const _AD = useSelector(e => e?.common?.authData)
    const [fieldValue, setFieldValue] = useState({
        isEmailMFA: false,
        isAuthenticatorAppMFA: false,
    })
    const [open, setOpen] = useState(null)
    const [generatedData, setGeneratedData] = useState({
        MFAQrCode: '',
        MFASecretKey: '',
        recoveryCode: ''
    })
    const [validateOTP, setValidateOTP] = useState('');
    const [verifyOTP, setVerifyOTP] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handle = {
        checkbox: (e) => {
            const {name, checked} = e.target
            setFieldValue({
                ...fieldValue,
                [name]: checked,
            })
        },
        generateQRCode: (e) => {
            e.preventDefault()
            e.stopPropagation()
            sendData(dispatch, 'hrms|master|MFA|generateQRCode', {})
        
        },
        cancel: () => {
            history?.goBack();
        },
        save: (e) => {
            e.preventDefault() 
            e.stopPropagation()
            let params = {
                MFA: {
                    isEmailMFA: fieldValue?.isEmailMFA ?? false,
                    isAuthenticatorAppMFA: fieldValue?.isAuthenticatorAppMFA ?? false,
                    MFAQrCode: fieldValue?.isAuthenticatorAppMFA ? generatedData?.MFAQrCode : null,
                    MFASecretKey: fieldValue?.isAuthenticatorAppMFA ? generatedData?.MFASecretKey : null,
                    recoveryCode: fieldValue?.isAuthenticatorAppMFA ? generatedData?.recoveryCode : null,
                }
            }
            sendData(dispatch, 'hrms|master|MFA|setup', params)
        }
    }

    useEffect(() => {
        if (validateOTP?.length === 6) {
            sendData(dispatch, 'hrms|master|MFA|verify', {
                otp: validateOTP,
                MFASecretKey: generatedData?.MFASecretKey,
            })
        }
    }, [validateOTP])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'hrms|master|MFA|read':
                    if (res?.data?.MFA) {
                        setFieldValue({
                            ...fieldValue,
                            isEmailMFA: res?.data?.MFA?.isEmailMFA,
                            isAuthenticatorAppMFA: res?.data?.MFA?.isAuthenticatorAppMFA,
                        })
                    }
                    break;
                case 'hrms|master|MFA|generateQRCode':
                    setGeneratedData({
                        ...generatedData,
                        MFAQrCode: res?.data?.MFAQrCode,
                        MFASecretKey: res?.data?.MFASecretKey,
                        recoveryCode: res?.data?.recoveryCode
                    });
                    break;
                case 'hrms|master|MFA|verify':
                    setVerifyOTP(res?.data?.success);
                    if (res?.data?.success) showToastSuccess('OTP verified successfully')
                    else showToastError('Invalid OTP')
                    break;
                case 'hrms|master|MFA|setup':
                    history.push('/login')
                    showToastSuccess('Multi-Factor Authentication Setup Successfully')
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res?.error?.message)
            switch (res?.code) {
                case 401:
                    history.push('/login')
                    break;
                default:
                    return true;
            }
        }
    })

    useEffect(() => {
        refresh();
        sendData(dispatch, 'hrms|master|MFA|read', {})
        return () => off();
    }, [])

    useEffect(() => {
        if(_AD ? false : (!_LID?.identifier || !_LID?.password)) {
            history.push('/login')
        }
    }, [_LID, _AD])

    return (
        <LayoutV2 module="setupMultiFactor" className="u_two-fa-setup">
            <div className="u_p-24">

                <div className="u_flex u_content-center u_mb-16">
                    <div className="u_border-radius-8 u_b-light u_p-12">
                        <Icon.Lock size={24} fill={COLOR.u_icon_bg} />
                    </div>
                </div>
                <div className="u_text-center u_mb-24">
                    <h3 className="u_title u_text-bold u_mt-16 u_mb-12">Setup Multi-Factor authentication</h3>
                    <p className="u_small-font">Secure your account with an additional layer of protection</p>
                </div>

                <div className="u_mt-24">
                    {(_AD?.email || _LID?.email) && <div className="u_w-full">
                        <UCheckBox
                            id="isEmailMFA"
                            label="With work email"
                            checked={fieldValue?.isEmailMFA}
                            name="isEmailMFA"
                            onChange={handle.checkbox}
                            className="u_mb-16"
                            testId={TEST_ID.SETUP_MFA.CHECKBOX} />
                    </div>}
                    <div className="u_w-full">
                        <UCheckBox
                            id="isAuthenticatorAppMFA"
                            label="With Google Authenticator App"
                            checked={fieldValue?.isAuthenticatorAppMFA}
                            name="isAuthenticatorAppMFA"
                            onChange={handle.checkbox}
                            className="u_mb-24"
                            testId={TEST_ID.SETUP_MFA.CHECKBOX} />
                    </div>
                    {fieldValue?.isAuthenticatorAppMFA && <div>
                        <div className="u_flex u_content-center">
                            <button
                                type="button"
                                className="u_btn u_btn__blue u_generate-qr-code u_mb-16"
                                disabled={generatedData?.MFAQrCode}
                                onClick={(e) => handle.generateQRCode(e)}
                                data-testid={TEST_ID.SETUP_MFA.VERIFY_BUTTON}>
                                <Icon.QRCode fill={COLOR.u_white} size={16} className='u_mr-8'/>
                                {generatedData?.MFAQrCode ? 'QR Code Generated' : 'Generate QR Code'}
                            </button>
                        </div>
                        {generatedData?.MFAQrCode && generatedData?.MFASecretKey && <div className="">
                            {/* QR Code */}
                            <div className='u_flex u_content-center'>
                                <img src={generatedData?.MFAQrCode} alt="QR Code" className='u_b-light' />
                            </div>
                            <div className='u_text-center u_my-16'>
                                <p className='u_small-font u_mb-8'>You don’t want to scan?
                                    <span className='u_small-font u_color-blue u_cp u_ml-4' onClick={() => setOpen(true)} >How it work?</span>
                                </p>
                            </div>

                            {/* OTP */}
                            <div className={`u_otp u_mb-16`}>
                                <OtpInput
                                    value={validateOTP}
                                    onChange={(e) => setValidateOTP(e)}
                                    isInputNum={true}
                                    containerStyle={'u_otp-container'}
                                    inputStyle={'u_otp-input'}
                                    numInputs={6}
                                    shouldAutoFocus={true}
                                    separator={<span> </span>}
                                />
                            </div>
                        </div>}
                        
                        {errorMsg?.length !== 0 && <p className="u_error-message">{errorMsg ?? ''}</p>}
                    </div>}

                    <div className="u_col-8 u_m-auto">
                        <div className="u_flex u_content-between">
                            <UButton
                                type="cancel"
                                variant="white"
                                onClick={handle.cancel}
                                testId={TEST_ID.SETUP_MFA.VERIFY_BUTTON} />

                            <UButton
                                disabled={fieldValue?.isAuthenticatorAppMFA ? !verifyOTP : !fieldValue?.isEmailMFA}
                                type="save"
                                variant="blue"
                                onClick={handle.save}
                                testId={TEST_ID.SETUP_MFA.VERIFY_BUTTON} />
                        </div>
                    </div>

                    {fieldValue?.isAuthenticatorAppMFA && generatedData?.recoveryCode && <div className='u_my-16 u_flex-align'>
                        <div className="u_flex-align u_recovery-code u_bg-thead" onClick={() => copyLink(generatedData?.recoveryCode, 'Recovery Code')} >
                            <div className="u_w-full u_mr-8">
                                <p className='u_color-title u_small-font u_mb-6 u_text-bold'>Recovery Code : </p>
                                <p className="u_color-title u_small-font">
                                    {generatedData?.recoveryCode ?? ''}
                                </p>
                            </div>
                            <div className='u_copy-code'>
                                <UPopup
                                    params={{className: 'u_tooltip'}}
                                    desc={<span>Copy Recovery Code</span>}
                                >
                                    <span className="u_cp u_lh-0">
                                        <Icon.Copy size={16} fill={COLOR.u_icon_bg}/>
                                    </span>
                                </UPopup>
                            </div>
                        </div>
                    </div>}

                    {fieldValue?.isAuthenticatorAppMFA && generatedData?.recoveryCode && <div className="u_mt-20">
                        <UAlertMessage danger full>
                            <strong>Important Note : </strong>
                            <span className="u_color-title">
                                If your authenticator app is unavailable or you’ve removed the MFA account, simply use your recovery code to regain access.
                            </span>
                        </UAlertMessage>
                    </div>}
                </div>
            </div>
            {open && <UModal
                open={open}
                maxWidth={600}
                onClose={() => setOpen(null)}
                header={<h4>How it work?</h4>}
                testId={TEST_ID.SETUP_MFA.MODAL}>
                <div className="u_p-16 u_two-fa-setup">
                    <p className="u_color-title u_mb-16">1. Open the Google Authenticator app on your phone.</p>
                    <p className="u_color-title u_mb-16">2. Tap the <strong>+</strong> button.</p>
                    <p className="u_color-title u_mb-16">3. Choose <strong>"Enter a setup key"</strong>.</p>
                    <p className="u_color-title u_mb-16">
                        4. Enter the setup key: 
                        <div className="u_flex-align u_recovery-code u_bg-thead u_mt-12" onClick={() => copyLink(generatedData?.MFASecretKey, 'Setup key')} >
                            <div className="u_w-full u_mr-8">
                                <p className='u_color-title u_small-font u_mb-6 u_text-bold'>Setup key : </p>
                                <p className="u_color-title u_small-font">
                                    {generatedData?.MFASecretKey ?? ''}
                                </p>
                            </div>
                            <div className='u_copy-code'>
                                <UPopup
                                    params={{className: 'u_tooltip'}}
                                    desc={<span>Copy Setup key</span>}
                                >
                                    <span className="u_cp u_lh-0">
                                        <Icon.Copy size={16} fill={COLOR.u_icon_bg}/>
                                    </span>
                                </UPopup>
                            </div>
                        </div>
                    </p>
                </div>
            </UModal>}
        </LayoutV2>
    );
};

export default SetUpMultiFactor;
